import { removeProtocolAndWww } from "app/pages/digital-marketing/utils/url";

export const cleanUrlForDisplay = (url: string): string => {
    const stripped = removeProtocolAndWww(url);
    try {
        return decodeURIComponent(stripped);
    } catch {
        return stripped;
    }
};
